import './message.scss';
//shared
import IMessage from '../../interfaces/message.interface';
//material
import { useState, forwardRef, useImperativeHandle } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Slide, { SlideProps } from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';



function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="up" />;
}

const Message = forwardRef(({ data }: {data: IMessage}, ref) => {
    const [state, setState] = useState<{
        open: boolean;
        Transition: React.ComponentType<
            TransitionProps & {
                children: React.ReactElement<any, any>;
            }
        >;
    }>({
        open: false,
        Transition: SlideTransition,
    });

    const handleClose = () => {
        setState({
            ...state,
            open: false,
        });
    };

    useImperativeHandle(ref, () => ({
        show() {
            setState({
                ...state,
                open: true,
            });
        }
    }))

    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                 }}
                className={data.style}
                open={state.open}
                onClose={handleClose}
                TransitionComponent={state.Transition}
                message={data.textMessage}
                key={state.Transition.name}
                autoHideDuration={data.duration}
            />
        </>
    )
});

export default Message;